
import React from 'react';
import { NavLink, Link } from 'react-router-dom';


const Factory = ( model, rolePermissions, user, setIsUserMenuOpen, logout, metadata ) => {
  return (
    <> 
      <div className="topbar-popover-header">
        <strong>{user?.fullName || 'Profile'}</strong>
        <span>{user?.email || 'No email'}</span>
      </div>
      
      <button
        className="topbar-user-menu-button"
        onClick={() => {
          setIsUserMenuOpen(false);
          logout();
        }}
        type="button"
      >
        Log out
      </button>
    </>
  );
};

export default Factory;